export default "__VITE_ASSET__080e352c__"